import { render, staticRenderFns } from "./AnalyticCollaborator.vue?vue&type=template&id=107b62b1&scoped=true&"
import script from "./AnalyticCollaborator.vue?vue&type=script&lang=js&"
export * from "./AnalyticCollaborator.vue?vue&type=script&lang=js&"
import style0 from "./AnalyticCollaborator.vue?vue&type=style&index=0&id=107b62b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107b62b1",
  null
  
)

export default component.exports